module.exports = __webpack_public_path__ + "static/media/gr.3ea5b964.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gr.svg
// module id = 2104
// module chunks = 0